import { connect } from 'react-redux';
import { setFilterPanelVisibility } from '../redux/filterPanel';

const mapDispatchToProps = (dispatch, { isFilterPanelOpen }) => ({
  onToggleFilterPanelVisibility() {
    dispatch(setFilterPanelVisibility({ isFilterPanelOpen: !isFilterPanelOpen }));
  },
});

const mapStateToProps = ({ filterPanel: { isFilterPanelOpen } }) => ({ isFilterPanelOpen });

export default Component =>
  connect(mapStateToProps)(connect(null, mapDispatchToProps)(Component));
